/** RTK Query tag list — every entity's `api/` endpoint tags/invalidates from this fixed set,
 *  registered once on `baseApi` so `injectEndpoints` callers don't redeclare it. */
export const TAG_TYPES = [
  'Me',
  'Memberships',
  'Store',
  'Settings',
  'Warehouse',
  'Category',
  'Supplier',
  'Product',
  'Stock',
  'Client',
  'Connection',
  'Order',
  'Payment',
  'ShopCatalog',
] as const;

export type TagType = (typeof TAG_TYPES)[number];
